// extracted by mini-css-extract-plugin
module.exports = {"action-image":"ActionCard_action-image__2lGbX","action-name":"ActionCard_action-name__2Qtc0","action-description":"ActionCard_action-description__-pCvr"};